import { CountryCode } from '@heidi/schema/ml-scribe';

/**
 * The countries a patient phone picker offers: every ISO 3166-1 alpha-2 code in
 * the backend `CountryCode` enum, in its order, minus the `XX` "others"
 * placeholder.
 *
 * Territories with no dialling plan (e.g. `AQ`, `BV`, `HM`) stay in the list;
 * the phone input drops any code its metadata does not know.
 */
export const PATIENT_PHONE_COUNTRIES: CountryCode[] = Object.values(CountryCode).filter(
  (code) => code !== CountryCode.XX
);
